var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarFilterIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 16,
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.0161 0.994551C16.9199 0.772294 16.7605 0.58322 16.5577 0.450844C16.3549 0.318468 16.1176 0.248632 15.8755 0.25002H2.12547C1.88354 0.250497 1.64695 0.321169 1.44439 0.453463C1.24184 0.585757 1.08203 0.773988 0.984348 0.99532C0.886667 1.21665 0.855314 1.46158 0.894092 1.70038C0.932871 1.93918 1.04011 2.16159 1.20281 2.34065L1.20906 2.34768L6.50047 7.99768V14C6.50041 14.2263 6.56176 14.4483 6.67796 14.6424C6.79417 14.8365 6.96087 14.9954 7.1603 15.1022C7.35973 15.209 7.58441 15.2597 7.81038 15.2489C8.03636 15.238 8.25515 15.1661 8.44344 15.0406L10.9434 13.3735C11.1148 13.2593 11.2553 13.1046 11.3525 12.923C11.4497 12.7415 11.5005 12.5387 11.5005 12.3328V7.99768L16.7927 2.34768L16.7989 2.34065C16.9633 2.16241 17.0716 1.9397 17.1102 1.70031C17.1488 1.46092 17.1161 1.21545 17.0161 0.994551ZM10.4208 7.32658C10.3127 7.44121 10.2518 7.59245 10.2505 7.75002V12.3328L7.75047 14V7.75002C7.75052 7.59131 7.69018 7.43853 7.58172 7.32268L2.12547 1.50002H15.8755L10.4208 7.32658Z",
  fill: "#CAC4CF"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarFilterIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_filter_icon.82054d374433e0fe3d0ca22f5683c725.svg";